import {ReactNode, useEffect} from "react";
import {auth} from "@/store/modules/auth.ts";
import {useDispatch} from "react-redux";

export type AuthLayoutType = {
    children: ReactNode;
    title?: string,
    subTitle?: string,
    icon?: any
};

export default function AuthLayout({children, title, subTitle, icon}: AuthLayoutType) {
    const dispatch = useDispatch<any>()

    useEffect(() => {
        dispatch(auth.mutation.setLoading(false))
    }, []);
    return (
        <main className="main-wrapper">
            <section className="login-form">
                <div className="padding-global wide">
                    <div className="login1_component">
                        <div className={"auth-card"}>
                            <div className="login1_navbar">
                                <img src="/images/login-logo.svg" loading="lazy" alt=""/>
                            </div>
                            <div className="margin-bottom margin-medium" style={{width: "40rem", marginBottom: "1rem"}}>
                                <div className="text-align-center">
                                    {icon &&
                                        <div style={{
                                            width: "100%",
                                            height: "100%",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}>
                                            <img src={icon} className={'w-[100px] mb-5 h-[100px]'} alt={''}/>
                                        </div>
                                    }
                                    <div style={{display: "flex", flexDirection: "column", gap: ".2rem", width: "102%"}}
                                         className="margin-bottom margin-small">
                                        <h1 className="heading-style-h2">{title}</h1>
                                        <p style={{fontWeight: "200"}}>
                                            {subTitle}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="div-block-6">
                                <div className="login1_form-block w-form">
                                    {children}
                                </div>
                            </div>
                            <div className="login1_footer">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="text-size-small" style={{paddingBottom: "4.8rem"}}>© {new Date().getFullYear()} Qoonity
            </div>
        </main>
    );
}
